module.exports = __webpack_public_path__ + "media/img/features/password-generator-large-2971b4674d37ff1d680488bcec291a6d.png";